function bindCarousel(section)
{
    const cards = Array.from(section.querySelectorAll('[data-partner-testimonial-index]'));
    const nextBtn = section.querySelector('[data-partner-testimonials-next]');

    if (cards.length <= 1 || !nextBtn) {
        return;
    }

    let activeIndex = cards.findIndex((card) => card.classList.contains('is-active'));

    if (activeIndex < 0) {
        activeIndex = 0;
        cards[0].classList.add('is-active');
    }

    nextBtn.addEventListener('click', () => {
        cards[activeIndex].classList.remove('is-active');
        activeIndex = (activeIndex + 1) % cards.length;
        cards[activeIndex].classList.add('is-active');
    });
}

export default function init()
{
    const sections = document.querySelectorAll('[data-partner-testimonials]');

    sections.forEach(bindCarousel);
}
